import React from 'react';
import { Box, Typography, Paper, Container, Divider, Link } from '@mui/material';

const ConsentPage: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          📄 Согласие на обработку персональных данных
        </Typography>
        
        <Typography variant="body2" color="text.secondary" gutterBottom>
          В соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных»
        </Typography>

        <Paper sx={{ p: 4, mt: 3 }}>
          <Typography variant="h5" gutterBottom fontWeight="bold">
            1. Оператор персональных данных
          </Typography>
          <Typography paragraph>
            <strong>Индивидуальный предприниматель Аспиндзов Сергей Александрович</strong>
            <br/>
            ИНН: 262800006730
            <br/>
            Email: asc.asp@yandex.ru
            <br/>
            Telegram: @asc_asp
            <br/>
            далее именуемый «Оператор».
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom fontWeight="bold">
            2. Субъект персональных данных
          </Typography>
          <Typography paragraph>
            Физическое лицо, использующее сервис «nashrelax.ru» (далее — Сервис), 
            доступный по адресу: <strong>https://nashrelax.ru</strong>, 
            далее именуемый «Пользователь».
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom fontWeight="bold">
            3. Перечень персональных данных
          </Typography>
          <Typography paragraph>
            Пользователь предоставляет Оператору следующие персональные данные:
          </Typography>
          <ul>
            <li>Telegram ID (уникальный идентификатор в Telegram)</li>
            <li>Username (имя пользователя в Telegram)</li>
            <li>Фамилия, имя (из профиля Telegram)</li>
            <li>Номер телефона (опционально, из профиля Telegram)</li>
            <li>Адрес электронной почты (опционально, при OAuth-авторизации)</li>
            <li>Данные о созданных и посещаемых мероприятиях</li>
            <li>IP-адрес и данные об устройстве (для обеспечения безопасности)</li>
          </ul>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom fontWeight="bold">
            4. Цели обработки персональных данных
          </Typography>
          <Typography paragraph>
            Обработка персональных данных осуществляется в следующих целях:
          </Typography>
          <ul>
            <li>Идентификация Пользователя в Сервисе</li>
            <li>Предоставление доступа к функционалу Сервиса</li>
            <li>Создание и управление мероприятиями</li>
            <li>Запись на мероприятия и участие в них</li>
            <li>Отправка уведомлений о мероприятиях</li>
            <li>Обеспечение безопасности Сервиса</li>
            <li>Улучшение качества обслуживания</li>
          </ul>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom fontWeight="bold">
            5. Действия с персональными данными
          </Typography>
          <Typography paragraph>
            Оператор осуществляет следующие действия с персональными данными:
          </Typography>
          <ul>
            <li>Сбор</li>
            <li>Запись</li>
            <li>Систематизация</li>
            <li>Накопление</li>
            <li>Хранение</li>
            <li>Уточнение (обновление, изменение)</li>
            <li>Извлечение</li>
            <li>Использование</li>
            <li>Передача (предоставление, доступ)</li>
            <li>Обезличивание</li>
            <li>Блокирование</li>
            <li>Удаление</li>
            <li>Уничтожение</li>
          </ul>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom fontWeight="bold">
            6. Передача персональных данных третьим лицам
          </Typography>
          <Typography paragraph>
            Оператор передаёт персональные данные следующим третьим лицам:
          </Typography>
          <ul>
            <li>
              <strong>Telegram Messenger LLP</strong> — для аутентификации пользователя 
              (Telegram ID, username, имя, фамилия, телефон)
            </li>
            <li>
              <strong>Google Ireland Limited</strong> — при OAuth-авторизации через Google 
              (email, имя, фамилия, аватар)
            </li>
            <li>
              <strong>Яндекс</strong> — при OAuth-авторизации через Яндекс 
              (email, имя, фамилия, аватар)
            </li>
          </ul>
          <Typography paragraph>
            В остальных случаях Оператор <strong>не передаёт</strong> персональные данные 
            третьим лицам без согласия Пользователя, за исключением случаев, 
            предусмотренных законодательством РФ.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom fontWeight="bold">
            7. Срок действия согласия
          </Typography>
          <Typography paragraph>
            Настоящее согласие действует бессрочно до момента его отзыва Пользователем.
          </Typography>
          <Typography paragraph>
            Персональные данные хранятся до:
          </Typography>
          <ul>
            <li>Отзыва согласия Пользователем</li>
            <li>Удаления аккаунта Пользователем</li>
            <li>Прекращения использования Сервиса</li>
          </ul>
          <Typography paragraph>
            После отзыва согласия данные удаляются в течение 30 дней, 
            за исключением данных, подлежащих хранению в соответствии с законодательством РФ.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom fontWeight="bold">
            8. Порядок отзыва согласия
          </Typography>
          <Typography paragraph>
            Пользователь может отозвать согласие на обработку персональных данных:
          </Typography>
          <ul>
            <li>Через страницу «Мои данные» в Сервисе (/my-data)</li>
            <li>Направив письменное заявление на email: asc.asp@yandex.ru</li>
          </ul>
          <Typography paragraph>
            Отзыв согласия влечёт за собой невозможность дальнейшего использования Сервиса.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom fontWeight="bold">
            9. Права субъекта персональных данных
          </Typography>
          <Typography paragraph>
            В соответствии с Федеральным законом № 152-ФЗ, Пользователь имеет право:
          </Typography>
          <ul>
            <li>На получение информации о своих персональных данных</li>
            <li>На уточнение персональных данных</li>
            <li>На блокирование или уничтожение персональных данных</li>
            <li>На отзыв согласия на обработку персональных данных</li>
            <li>На защиту своих прав и законных интересов</li>
            <li>На возмещение убытков и компенсацию морального вреда</li>
          </ul>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom fontWeight="bold">
            10. Меры защиты персональных данных
          </Typography>
          <Typography paragraph>
            Оператор принимает необходимые организационные и технические меры для защиты 
            персональных данных от неправомерного или случайного доступа, уничтожения, 
            изменения, блокирования, копирования, предоставления, распространения.
          </Typography>
          <Typography paragraph>
            Данные хранятся на серверах на территории Российской Федерации.
            Передача данных осуществляется по защищённому протоколу HTTPS.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" gutterBottom fontWeight="bold">
            11. Заключительные положения
          </Typography>
          <Typography paragraph>
            Настоящее Согласие вступает в силу с момента его принятия Пользователем 
            (простановки галочки в чекбоксе «Я даю согласие на обработку персональных данных»).
          </Typography>
          <Typography paragraph>
            Оператор оставляет за собой право вносить изменения в настоящее Согласие. 
            Актуальная версия всегда доступна на странице: 
            <Link href="/consent" underline="hover"> /consent</Link>
          </Typography>

          <Box sx={{ mt: 4, p: 3, bgcolor: 'info.light', borderRadius: 2 }}>
            <Typography variant="body2">
              <strong>Реквизиты Оператора:</strong>
              <br/>
              ИП Аспиндзов Сергей Александрович
              <br/>
              ИНН: 262800006730
              <br/>
              Email: asc.asp@yandex.ru
              <br/>
              Telegram: @asc_asp
            </Typography>
          </Box>
        </Paper>

        <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
          <Link href="/privacy-policy" underline="hover">
            ← Политика конфиденциальности
          </Link>
          <Link href="/my-data" underline="hover">
            Мои данные →
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default ConsentPage;
